import providerProfileTransformer from '../../transformers/providerProfile';

import axios from 'axios';
export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + `providers/${id}`).then(
      ({ data }) => {
        let profile = {};
        if (data.data) {
          profile = providerProfileTransformer.fetch(data.data);
        }
        resolve(profile);
      },
      (error) => {
        console.log(error);
        reject(error);
      }
    );
  });

  return promise;
};
